import styled from "styled-components/macro";
import { PlayVideo } from "../../../assets/iconComponents/PlayVideo";
import { DeviceType } from "../../../utils/hooks/useDeviceHook";

const getVideoPlayWidth = (
  deviceType: DeviceType,
  variant?: "page" | "panel",
) => {
  if (variant === "panel") return "100%";
  if (deviceType === "desktop") return "510px";
  return "400px";
};

export const VideoDiv = styled.div<{ $variant?: "page" | "panel" }>`
  text-align: center;
  width: 100%;
  height: 100%;

  ${({ $variant }) =>
    $variant === "panel" &&
    `
      overflow: hidden;
      border-radius: 4px;
    `}
`;

export const IconAndTypographyContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const VideoIconAndTypography = styled.div`
  align-items: center;
  display: inline-flex;
  gap: 14px;
  justify-content: center;
`;

export const VideoPlayContainer = styled.div<{
  deviceType: DeviceType;
  $variant?: "page" | "panel";
}>`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: ${({ $variant }) => ($variant === "panel" ? "8px" : "10px")};
  height: ${({ $variant }) => ($variant === "panel" ? "60px" : "87px")};
  width: ${({ deviceType, $variant }) =>
    getVideoPlayWidth(deviceType, $variant)};
  place-items: center;
`;

export const VideoIconImg = styled.img`
  margin-top: -2px;
`;

export const StyledPlayVideo = styled(PlayVideo)`
  margin-bottom: 2px;
`;
